import React from "react";
import { useHistory } from "react-router-dom";
import { NORMALIZE_GRAD_CD } from "components/mypage/myExamInfo/examConstants";
import usexAPI from "store/customHooks/usexAPI";
import { xAPI_ID_VALUE } from "utils/xAPI_PATH";
import { EXAM_PLAN_XAPI_CONTENT } from "./examPlanXapi";
import "./ExamPlanFinalCard.scss";

function ExamPlanFinalCard({ completeMissionCount, totalMissionCount, onInfoClick, gradCd }) {
    const history = useHistory();
    const { ServiceUnit_B } = usexAPI();
    // 최종 미션 GO 는 시험정보 목록이 아니라 성적 입력 화면으로 바로 들어간다.
    const openExamScore = () => {
        ServiceUnit_B(xAPI_ID_VALUE.serviceUnit.btn_epm_0009).setContent(EXAM_PLAN_XAPI_CONTENT).selected();
        history.push(`/mypage/myExamScore?GRAD_CD=${NORMALIZE_GRAD_CD(gradCd) || ""}`);
    };
    return (
        <div className="expln-final">
            <div className="expln-final__upp">
                <div className={`expln-final__trophy expln-final__trophy--count-${completeMissionCount}`} />
                <div className="expln-final__count">
                    <span className="expln-final__count-current">{completeMissionCount}</span>
                    <span className="expln-final__count-total">/ {totalMissionCount}</span>
                </div>
                <div className="expln-final__rwd">10,000개</div>
            </div>

            <div className="expln-final__btm">
                <button type="button" className="expln-final__info" onClick={onInfoClick} />
                <div className="expln-final__tag">최종 미션</div>
                <h2 className="expln-final__tit">시험 성적 등록</h2>
                <button className="expln-final__btn" type="button" onClick={openExamScore} />
            </div>
        </div>
    );
}

export default React.memo(ExamPlanFinalCard);
